import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
const id = `iframe_${new Date().getTime()}`;

const createMarkup = function createMarkup(src) {
    return {
        __html: `<iframe width="764" height="290" scrolling="no" frameborder="no" border="0" style="border:0px; margin:0px;padding:0px;" id="${id}" src="${src}"></iframe>`,
    };
};

class Iframe extends React.PureComponent {
    /**
     * 渲染组件
     */

    componentDidMount = () => {
        // const iframe = document.getElementById(id);
        // console.log(iframe);
        // const iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
        // if (iframeWin.document.body) {
        //     iframe.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
        // }
    };

    static propTypes = {
        src: PropTypes.string,
    };

    render() {
        const { src } = this.props;

        return <div className={styles.capital} dangerouslySetInnerHTML={createMarkup(src)} />;
    }
}

export default errorBoundary(Iframe);
